import React, { useEffect, useState } from 'react';
import { useQuill } from 'react-quilljs';
import PropTypes from 'prop-types';
import 'quill/dist/quill.snow.css';
import './MessageInputEditor.scss';
import lang from '../../../../components/language/services/Lang';
import { useSelector } from 'react-redux';

const MessageInputEditor = ({ onInputChanged, messageContent, disabled, ticketId }) => {

    const language = useSelector(state => (state.layout.lang || 'EN').toUpperCase())

    const [quillInitialized, setQuillInitialized] = useState(false);

    const theme = 'snow';

    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link']
        ],
    }

    const formats = [
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet', 'indent',
        'link'
    ]

    const placeholder = lang.getValue('Messages.SendMessagePlaceholder', language);

    const { quill, quillRef } = useQuill({ theme, modules, formats, placeholder });

    useEffect(() => {
        // since we aren't using this as a regular input
        // we only care if the content has been cleared by the parent.
        // In this case, clear the input, but we can safely ignore all other updates.
        if (!messageContent && !!quill) {
            quill.setText('')
            if (ticketId) localStorage.removeItem(`unsentMessage_${ticketId}`);
        }
    }, [messageContent])

    useEffect(() => {
        // this would be better if it could be css, but that's not an option here.
        if (quill) {
            if (disabled) {
                quill.disable()
            } else {
                quill.enable()
            }
        }
    }, [disabled])

    // Load unsent message on mount
    useEffect(() => {
        if (quill && ticketId) {
            const saved = localStorage.getItem(`unsentMessage_${ticketId}`);
            if (saved && !messageContent) {
                quill.clipboard.dangerouslyPasteHTML(saved);
                onInputChanged(saved);
                // Move cursor to end
                const length = quill.getLength();
                quill.setSelection(length, 0);
            }
        }
    }, [quill, ticketId]);

    useEffect(() => {
        if (quill && !messageContent) {
            quill.setText('');
            if (ticketId) localStorage.removeItem(`unsentMessage_${ticketId}`);
        }
    }, [messageContent]);

    useEffect(() => {
        // set up event handlers for the quill editor
        if (quill && !quillInitialized) {
                setQuillInitialized(true)

                quill.on('text-change', (delta, oldDelta, source) => {
                    const html = quillRef.current.firstChild.innerHTML;
                    onInputChanged(html);
                    // Save to localStorage
                    if (ticketId) localStorage.setItem(`unsentMessage_${ticketId}`, html);
                });
            }
    }, [quill]);

    useEffect(() => {
        if (quillInitialized) {
            let editor_elements = document.getElementsByClassName('ql-editor')
            if (editor_elements) {
                editor_elements[0]?.classList.toggle('editor-custom-scroll')
            }
        }
    }, [quillInitialized])

    return (<div className='quill mb-1 message-textarea'>
        <div ref={quillRef} id='quill-input' className='editor-custom-scroll' />
    </div>)
}

MessageInputEditor.propTypes = {
    onInputChanged: PropTypes.func.isRequired,
    messageContent: PropTypes.string,
    disabled: PropTypes.bool
}

export default MessageInputEditor